<div>
    <h1>Application timed out</h1>
</div>
<div class="icbc-alert-box icbc-alert-box-warning">
    <div>
        <mat-icon class="icbc-alert-icon">error_outline</mat-icon>
    </div>
    <div class="icbc-alert-box-warning-text">
        Please try again or <a
            href="http://www.icbc.com/driver-licensing/getting-licensed/Pages/Your-driving-record.aspx"
            target="_blank" class="icbc-link">request your abstract and/or claims history letter in person, by phone or by mail</a>.
    </div>
</div>